import { useContext } from 'react';
import { PortfolioPerformanceContext } from '../../../../providers/portfolio-performance';
import { AggregatedExchangeAccountList } from '../../../shared/aggregated-accounts-list';

export const PortfolioPerformanceAccountsSection = ({
  isSidebarOpen,
  accountGroups,
}: {
  isSidebarOpen: boolean;
  accountGroups: any[];
}) => {
  const { selectedAccounts, setSelectedAccounts, isNamesBlurred } = useContext(
    PortfolioPerformanceContext,
  );

  return (
    <div className="portfolio-accounts-section">
      {accountGroups.map((group) => (
        <AggregatedExchangeAccountList
          key={group.exchange}
          exchange={group.exchange}
          label={group.exchange.charAt(0).toUpperCase() + group.exchange.slice(1)}
          icon={group.icon}
          credentials={[group]}
          isPortfolioSidebarOpen={isSidebarOpen}
          selectedAccountsAggregated={selectedAccounts}
          setSelectedAccountsAggregated={setSelectedAccounts as any}
          // Reference strategy names (BTC/ETH/...) aren't sensitive - only
          // blur real traded-exchange accounts.
          isBlurred={isNamesBlurred && group.exchange !== 'reference'}
        />
      ))}
    </div>
  );
};
